import { AppStoreDynamicForm } from './store.dynamic-form';

export const appStoreDynamicFormIS: AppStoreDynamicForm = {
  answers: {},
};
